import React, { useState } from 'react';
import './formClient.scss'
import PerfilView from '../../Forms/PerfilView'
import Answer from '../Answer';
import axios from 'axios';
import { Formik } from 'formik';
import { validationClienteForm } from '../../../utils/validations';
import {eventTagM } from '../../../utils/Google/TagManager'

const FormClient = ({ refInputName, onModal, client, user }) => {

  const [sendAnswer, setSendAnswer] = useState(false)

  const initialValues = {
    name: '',
    email: '',
    phone: '',
    description: '',
    infoAdicional: false
  };

  const handleSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    let clientMes = client && client.uid ? client.uid : '';
    let uid = user && user.role === "lawyer" && user.idLawFirm && user.idLawFirm !== undefined ? user.idLawFirm : 'no-uid';
    let data =  {
      "name":  values.name,
      "phone": values.phone,
      "email": values.email,
      "clientUid": clientMes,
      "infoAdicional": values.infoAdicional,
      "lawyerUid": user.uid,
      "role":user.role,
      "text": values.description,
      "type":"messages",
      "messageNotification":{
          "title":values.name,
          "text": "Te ha contactado.",
          "instruction": "Para dar seguimiento y cerrar una cita, da click en  esta notificación."
      },
      "typeAnalitics":"formMessage",
      "idLawFirm": uid
    }
    console.log(data)

    // Pasar la url , la data y  el header(tipo de contenido = json)
    axios.post(`${process.env.REACT_APP_FIREBASE_URLSERVICE}/create/create_data`, data, {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":"X-Requested-With",
        'Authorization': `Bearer ${'TgC1n73rN37Gr0u9'}`
      }
    }
    ).then(function (response) {
      //UID Client
      console.log("yeiii", response)
    }) 
      .catch(function (response) {
        console.log("nooo", response)
      }); 
      eventTagM('clientePontencial')

    setSendAnswer(true)
  }

  const tituloNombre = (auth) => {
    switch (auth && auth.gradeStudy) {
      case 'Licenciatura':
        return 'Lic.'
      case 'Maestría': {
        if (auth.genero === 'male') {
          return 'Mtro.'
        } else if (auth.genero === 'female') {
          return 'Mtra.'
        }
        return null
      }
      case 'Especialidad': return 'Esp.'
      case 'Doctorado': {
        if (auth.genero === 'male') {
          return 'Dr.'
        } else if (auth.genero === 'female') {
          return 'Dra.'
        }
        return 'auth.gradeStudy '
      }
      default: return '';
    }
  }

  return (
    <>
      <section className="cardContact">
        {!onModal && 
          <header className="cardContact_header">
            <figure className="cardContact_logo">
              <img src="/img/profileClient/w.svg" alt="" />
            </figure>
          </header>
        }

        {sendAnswer?
          <Answer user={user} /> :
          <>
            <article className="cardContact_timetable">

              {user ?
                (
                  <p>
                    {user && user.role === "lawFirm" ?
                      (user.officeName) :
                      user && user.lastName && !user.secondLastName ?
                      (`${tituloNombre(user)} ${user && user.name ? user.name : ''} ${user && user.lastName ? user.lastName : ''}`) :
                      (`${tituloNombre(user)} ${user && user.name ? user.name : ''} ${user && user.firstLastName ? user.firstLastName : ''} ${user && user.secondLastName ? user.secondLastName : ''}`)
                    }
                  </p>
                ) :
                null
              }              
            </article>
            <div className="cardContact_reply">
              <p style={{ margin: 0, fontWeight: 'bold' }}>
                {user &&
                user.role &&
                (user.role === 'lawFirm' ||
                user.role === 'lawyer') ?
                  'Ingresa tu información para visualizar los datos de contacto del Abogado.' :
                  'Ingresa tu información para visualizar los datos de contacto del Abogado.'
                }
              </p>
            </div>
            <article className="cardContact_info">
              <Formik
                initialValues={initialValues}
                validationSchema={validationClienteForm}
                onSubmit={handleSubmit}
                render={props => <PerfilView {...props} ref={refInputName} />}
              />
            </article>
          </>
        }

      </section>
    </>

  );
}

export default FormClient;